import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InstructorLandingPage.css'; // You can add your styles here
import teacherImage from '../../assets/teacher.png'; // Import the image

const InstructorLandingPage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/instructor-criteria');  // Navigates to the instructor criteria page (or the next page)
  };

  return (
    <div className="instructor-landing-page">
      <div className="homepage-text">
        <h1 className="in-hed">Teach the World with your wisdom</h1>
        <p>
          Turn what you know into an opportunity and reach millions of people
          around the world.
        </p>
        <button className="get-started-button" onClick={handleGetStarted}>
          Get Started
        </button>
      </div>
      <div className="instructor-page-image">
        <img className="Teacher-image" src={teacherImage} alt="Teacher" />
      </div>
    </div>
  );
};

export default InstructorLandingPage;
